import { render, staticRenderFns } from "./RedeemApp.vue?vue&type=template&id=2c1a4eb2&scoped=true"
import script from "./RedeemApp.vue?vue&type=script&lang=js"
export * from "./RedeemApp.vue?vue&type=script&lang=js"
import style0 from "./RedeemApp.vue?vue&type=style&index=0&id=2c1a4eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1a4eb2",
  null
  
)

export default component.exports